/**
 * Pure rules for the four OT chips (Weekly / Daily / Consecutive / Approaching) rendered by
 * `NurseShiftBadges`. Kept out of the component so both the threshold and the formatting are
 * directly testable, and so the next badge type has one obvious place to plug into.
 */

/**
 * APP-719: below an hour, an OT badge is noise — "Approaching OT 0.2h" costs a chip's worth of a
 * crowded shift row and changes no scheduling decision. Daily OT already had this gate inline; the
 * other three did not, so a sub-hour week still lit up the row. Applying it in one place is also
 * what stops the next badge type from being added ungated.
 *
 * Inclusive: an even 1h still shows, matching the Daily rule this generalizes.
 */
export const MIN_OT_BADGE_HOURS = 1;

export const shouldShowOtBadge = (overtimeHours: number): boolean => overtimeHours >= MIN_OT_BADGE_HOURS;

/**
 * Mobile has no room for the decimal — at the 8-10px chip font it is the first thing to become
 * unreadable — so phones round (1.2h reads "1h"). `shouldShowOtBadge` guarantees we never round a
 * rendered badge down to a meaningless "0h".
 */
export const formatOtBadgeHours = (overtimeHours: number, roundToWholeHours: boolean): string =>
	roundToWholeHours ? `${Math.round(overtimeHours)}` : overtimeHours.toFixed(1);
